import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "checked-icon" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]

import { IonLabel, IonPage, IonRouterOutlet, IonTabBar, IonTabButton, IonTabs } from "@ionic/vue"
import { computed, ref, watch } from "vue"
import { useRoute, useRouter } from "vue-router"
import { checkUserType } from "@/js/message"
import { getBrandImageUrl } from "@/js/brandImages.ts"
import store from "@/js/store"

type TabItem = {
  tab: string
  path: string
  label: string
  icon: string
  clickedIcon: string
}

/** platformFunction：空=仅首页；含2=自习室；含1=首页；1和2都有=都显示 */

export default /*@__PURE__*/_defineComponent({
  __name: 'TeacherTabs',
  setup(__props) {

function parsePlatformFunction(raw: unknown): Set<number> {
  const set = new Set<number>()
  if (raw == null || raw === "") return set
  const list = Array.isArray(raw)
    ? raw
    : String(raw)
        .split(/[,，\s]+/)
        .filter(Boolean)
  list.forEach((v) => {
    const n = Number(v)
    if (n === 1 || n === 2) set.add(n)
  })
  return set
}

function getTabVisibility() {
  const user = store.getCurrentUser?.() || {}
  const funcs = parsePlatformFunction(user?.platformFunction)
  const has1 = funcs.has(1)
  const has2 = funcs.has(2)
  // 为空：仅首页；含1=首页；含2=自习室
  return {
    showHome: !has1 && !has2 ? true : has1,
    showStudyRoom: has2,
  }
}

const allTabs: TabItem[] = [
  {
    tab: "teacher-home",
    path: "/TeacherIndex",
    label: "首页",
    icon: getBrandImageUrl("tabbar/home_icon.png"),
    clickedIcon: getBrandImageUrl("tabbar/home_active_icon.png"),
  },
  {
    tab: "teacher-study-room",
    path: "/StudyRoom",
    label: "自习室",
    icon: getBrandImageUrl("tabbar/stu_mine.png"),
    clickedIcon: getBrandImageUrl("tabbar/stu_mine_active.png"),
  },
  {
    tab: "teacher-record",
    path: "/ClassRecord",
    label: "训练记录",
    icon: getBrandImageUrl("tabbar/record_icon.png"),
    clickedIcon: getBrandImageUrl("tabbar/record_active_icon.png"),
  },
  {
    tab: "teacher-student",
    path: "/StudentList",
    label: "学员信息",
    icon: getBrandImageUrl("tabbar/student_icon.png"),
    clickedIcon: getBrandImageUrl("tabbar/student_active_icon.png"),
  },
  {
    tab: "teacher-mine",
    path: "/TeacherPersonalIndex",
    label: "个人中心",
    icon: getBrandImageUrl("tabbar/mine_icon.png"),
    clickedIcon: getBrandImageUrl("tabbar/mine_active_icon.png"),
  },
]

const currentIndex = ref(0)
const route = useRoute()
const router = useRouter()

const tabList = computed(() => {
  const { showHome, showStudyRoom } = getTabVisibility()
  return allTabs.filter((item) => {
    if (item.tab === "teacher-home") return showHome
    if (item.tab === "teacher-study-room") return showStudyRoom
    return true
  })
})

const pathList = computed(() => tabList.value.map((item) => item.path))

function changeBtn(type: number, event?: Event) {
  if (checkUserType()) {
    event?.preventDefault()
    event?.stopPropagation()
    return
  }
  // 已在当前 tab，阻止重复跳转
  if (currentIndex.value === type) {
    event?.preventDefault()
    return
  }
  currentIndex.value = type
}

function ensureVisibleRoute(path: string) {
  const { showHome, showStudyRoom } = getTabVisibility()
  if (path === "/TeacherIndex" && !showHome && showStudyRoom) {
    router.replace("/StudyRoom")
    return
  }
  if (path === "/StudyRoom" && !showStudyRoom && showHome) {
    router.replace("/TeacherIndex")
  }
}

watch(
  () => route.path,
  (newVal) => {
    ensureVisibleRoute(newVal)
    const idx = pathList.value.indexOf(newVal)
    if (idx >= 0) {
      currentIndex.value = idx
    }
  },
  { immediate: true }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonTabs), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonRouterOutlet)),
          _createVNode(_unref(IonTabBar), {
            slot: "bottom",
            class: "bottom-tabbar"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabList.value, (i, idx) => {
                return (_openBlock(), _createBlock(_unref(IonTabButton), {
                  key: i.tab,
                  class: _normalizeClass({ 'active-class': currentIndex.value === idx }),
                  tab: i.tab,
                  href: i.path,
                  onClick: ($event: any) => (changeBtn(idx, $event))
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("div", _hoisted_1, [
                      _createElementVNode("img", {
                        class: "pic",
                        src: i.clickedIcon,
                        alt: ""
                      }, null, 8, _hoisted_2)
                    ], 512), [
                      [_vShow, currentIndex.value === idx]
                    ]),
                    _withDirectives(_createElementVNode("img", {
                      class: "pic",
                      src: i.icon,
                      alt: ""
                    }, null, 8, _hoisted_3), [
                      [_vShow, currentIndex.value !== idx]
                    ]),
                    _createVNode(_unref(IonLabel), { class: "label" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(i.label), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["class", "tab", "href", "onClick"]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})